module.exports = __webpack_public_path__ + "img/export-walking-profile-degraded.65305514.svg";